"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zM11.13 14h1.75v1.75h-1.75zM12 5c-1.93 0-3.5 1.57-3.5 3.5h1.75c0-.96.79-1.75 1.75-1.75s1.75.79 1.75 1.75c0 1.76-2.62 1.54-2.62 4.38h1.75c0-1.97 2.62-2.19 2.62-4.38C15.5 6.57 13.93 5 12 5z"
})), 'NotListedLocationOutlined');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/NotListedLocationOutlined.js
// module id = 4339
// module chunks = 0